import { z } from 'zod';

/** Единственный источник значений поддерживаемых локалей. Добавление языка — здесь. */
export const LocaleSchema = z.enum(['ru', 'en']);
export type Locale = z.infer<typeof LocaleSchema>;

export const UpdateLocaleInput = z.object({
  locale: LocaleSchema,
});
export type UpdateLocaleInput = z.infer<typeof UpdateLocaleInput>;
